import { defaultService } from '../../../services'
import { alertActions } from '../../alert/alert.actions'
import { errorMessages } from '../../../messages'
import { govCertapplyConstants, uriConstants } from '../../../constants'
import authHeader from '../../../../module/auth-header'

/**
 * 서버가 로그인 사용자의 CI 를 직접 조회하는 정부 지갑 API 용 헤더.
 * (응답 CI 제거 — 요청 본문에 ci 를 싣지 않으므로 Bearer 토큰으로 로그인 사용자를 식별한다)
 */
function withAuthorization(headers) {
  const authorization = authHeader().Authorization
  authorization && headers.append('Authorization', authorization)
  return headers
}


export const govCertapplyActions = {
  getScreenURL,
  verifyIndiECDW,
  issueIndiECDW,
  inquireIndiECDWPopupList,
  changeIndiECDWInfo,
  inquireIndiStipAgree,

  getAplySupportList,
  showECDApplyPopup,
  closeECDApplyPopup,
  getECDApplyListInquire,
  ECDApplyQFVerify,
  ECDApply,
}

/**
 * 지갑 화면 URL 요청
 */
function getScreenURL(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.SCREEN_URL_LOAD_REQUEST))

    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }
    console.log(myHeaders)
    fetch(uriConstants.API_URI + uriConstants.GET_SCREEN_URL, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        dispatch(apiSuccess(govCertapplyConstants.SCREEN_URL_LOAD_SUCCESS, JSON.parse(result)))
      })
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.SCREEN_URL_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}
/**
 * 개인 전자문서지갑 주소 확인
 */
function verifyIndiECDW(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_REQUEST))

    var myHeaders = withAuthorization(new Headers())
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.VERIFY_INDI_ECDW, requestOptions)
      .then((response) => response.text())
      .then((result) => dispatch(apiSuccess(govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_SUCCESS, JSON.parse(result))))
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.VERIFY_INDI_ECDW_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}
/**
 *  개인 전자문서지갑 주소 발급
 */
function issueIndiECDW(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_REQUEST))

    var myHeaders = withAuthorization(new Headers())
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.ISSUE_INDI_ECDW, requestOptions)
      .then((response) => response.text())
      .then((result) => dispatch(apiSuccess(govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_SUCCESS, JSON.parse(result))))
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.ISSUE_INDI_ECDW_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

/**
 * 개인 전자문서지갑 팝업함 조회
 */
function inquireIndiECDWPopupList(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_REQUEST))

    var myHeaders = withAuthorization(new Headers())
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.INQUIRE_INDI_ECDW_POPUP_LIST, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        dispatch(apiSuccess(govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_SUCCESS, JSON.parse(result)))
      })
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.INQUIRE_INDI_ECDW_POPUP_LIST_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

/**
 * 개인 전자문서지갑 주소 정보 변경
 */
function changeIndiECDWInfo(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_REQUEST))

    var myHeaders = withAuthorization(new Headers())
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.CHANGE_INDI_ECDW_INFO, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        dispatch(apiSuccess(govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_SUCCESS, JSON.parse(result)))
      })
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.CHANGE_INDI_ECDW_INFO_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

/**
 * 약관동의 내용 조회
 */
function inquireIndiStipAgree(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_REQUEST))

    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.INQUIRE_INDI_STIP_AGREE, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        dispatch(apiSuccess(govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_SUCCESS, JSON.parse(result)))
      })
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.INQUIRE_INDI_STIP_AGREE_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

/**
 * 전자증명서 유통 서비스가 지원하는 전자증명서 종류 및 관련 정보 목록 조회
 */
function getAplySupportList(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_APLY_SUPPORT_LIST + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiSuccess(govCertapplyConstants.LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiFailure(govCertapplyConstants.LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 증명서 신청 목록 조회 API
 * @param {*} params
 * @returns
 */
function getECDApplyListInquire(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.INQUIRE_LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_APLY_LIST_INQUIRE + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiSuccess(govCertapplyConstants.INQUIRE_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiFailure(govCertapplyConstants.INQUIRE_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function ECDApplyQFVerify(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_REQUEST))

    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.ECD_APPLY_QF_VERIFY, requestOptions)
      .then((response) => response.text())
      .then((result) => dispatch(apiSuccess(govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_SUCCESS, JSON.parse(result))))
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.ECD_APPLY_QF_VERIFY_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

function ECDApply(params) {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.ECD_APPLY_LOAD_REQUEST))

    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Accept', 'application/json')

    var raw = JSON.stringify(params)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(uriConstants.API_URI + uriConstants.ECD_APPLY, requestOptions)
      .then((response) => response.text())
      .then((result) => dispatch(apiSuccess(govCertapplyConstants.ECD_APPLY_LOAD_SUCCESS, JSON.parse(result))))
      .catch((error) => {
        dispatch(apiFailure(govCertapplyConstants.ECD_APPLY_LOAD_FAILURE, error))
        dispatch(apiError(error))
      })
  }
}

function showECDApplyPopup() {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.SHOW_POPUP_ITEMS))
  }
}

function closeECDApplyPopup() {
  return (dispatch) => {
    dispatch(apiRequest(govCertapplyConstants.CLOSE_POPUP_ITEMS))
  }
}

/**
 * API응답처리 함수
 */
function apiRequest(type) {
  return {
    type: type,
  }
}

function apiSuccess(type, response) {
  return {
    type: type,
    response,
  }
}

function apiFailure(type, response) {
  return {
    type: type,
    response,
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

// dispatch(
//   alertActions.success({
//     title: '오류',
//     message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
//     params: {
//       type: 'success',
//       callback: () => {
//         // window.location.replace('/service/inbox')
//       },
//     },
//   }),
// )
